module.exports = __webpack_public_path__ + "img/greatView.ad2b689a.svg";